/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-04-20 14:39:02
 * @modify date 2020-04-20 14:39:02
 * @desc [description]
 */
import axios from 'axios';

/**
 * regulatory_watch_status get api
 * to get User Regulatory Update statuses */
export async function getRegulatoryWatchStatus() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/regulatory_watch_status`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('get regulatory_watch_status api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * regulatory_watch_status put api
 * to update the Regulatory Update statuses */
export async function updateRegulatoryWatchStatus(data) {
  let result = [];
  await axios
    .put(`${process.env.VUE_APP_PYTHON_API_URL}/regulatory_watch_status`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('put regulatory_watch_status api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getUserProdRegistration get api
 * to get User Prod Registration */
export async function getUserProdRegistration() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/user_product_registration`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('get user_product_registration api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getRegWatchDashboardCount() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/reg_watch_dashboard_count`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('get reg_watch_dashboard_count api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegulatoryAlertHistory get api
 * to get the RegulatoryAlert History */
export async function getRegulatoryAlertHistory(countryId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/regulatory_alert_history/${countryId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('get regulatory_alert_history python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * deleteMultiAlertsDetails delete api
 * to delete mutiple alert details */
export async function deleteMultiAlertsDetails(data) {
  let result = '';
  await axios
    .delete(`${process.env.VUE_APP_PYTHON_API_URL}/regulatory_alert`, { data })
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('delete regulatory_alert python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * saveRegulatoryAlert post api
 * to add new regulatory alert */
export async function saveRegulatoryAlert(data) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_PYTHON_API_URL}/regulatory_alert`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('save regulatory_alert python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getAllRegulatoryAlerts get api
 * to get all the Regulatory Alerts */
export async function getAllRegulatoryAlerts() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/regulatory_alert`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('get regulatory_alert python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getPublishedRegulatoryAlerts get api
 * to get Published Regulatory Alerts */
export async function getPublishedRegulatoryAlerts() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/published_regulatory_alerts`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('get published_regulatory_alerts python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * regulatory-update-covid get api
 * to get the regulatory-update-covid json data */
export async function getCOVID19Keys() {
  let result = [];
  await axios
    .get(
      `${process.env.VUE_APP_AZURE_BLOB_URL}/regulatory-updates-covid/regulatory-update-covid.json`
    )
    .then((response) => {
      if (response.status === 200) result = response.data.keys;
    })
    .catch((err) => {
      console.log('getCOVID19Keys blob json error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function getMatchedRecordsForGlobalSearch(payload) {
  let result = [];
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/global/search/result/match`, payload)
    .then((response) => {
      result = response.data.data;
      // if (response.status === 200) result = response.data.reg_alerts;
    })
    .catch((err) => {
      console.log('get matched record for gs error', err); // eslint-disable-line no-console
    });
  return result;
}
